import { useCancelOrderModal } from '../screens/bill/cancel-order-modal';
import { useErrorModal } from '../screens/error-modal';
import { useMenuManager } from '../utils/manager/menu-manager';

function useOrderCancelWorkflow() {
  const { prepareCancelOrderModal, showCancelOrderModal } =
    useCancelOrderModal();
  const { showErrorModal } = useErrorModal();
  const { loadMenu } = useMenuManager();

  async function prepare({ order }) {
    await prepareCancelOrderModal({ order });
  }

  async function show({ prepareOnPreConfirm }) {
    let retry = false;
    do {
      // eslint-disable-next-line no-await-in-loop
      const result = await showCancelOrderModal({ prepareOnPreConfirm });

      if (result.error != null) {
        // eslint-disable-next-line no-await-in-loop
        await loadMenu();
        // eslint-disable-next-line no-await-in-loop
        await showErrorModal(result.error);
      }

      retry = result.retry;
    } while (retry);
  }

  return {
    prepareOrderCancelWorkflow: prepare,
    showOrderCancelWorkflow: show,
  };
}

export { useOrderCancelWorkflow };
